<template>
  <div>
    <div style="text-align: left">
      <Chip
        :label="printControl.branchOffice.toString()"
        icon="pi pi-building"
        class="mr-2 mb-2"
        v-primeTooltip.top="{ value: 'Sucursal' }"
      />

      <Chip
        :label="printControl.insuranceLine.toString()"
        icon="pi pi-sitemap"
        class="mr-2 mb-2"
        v-primeTooltip.top="{ value: 'Ramo' }"
      />
      <Chip
        :label="printControl.policyNumber.toString()"
        icon="pi pi-file"
        class="mr-2 mb-2"
        v-primeTooltip.top="{ value: 'Póliza' }"
      />
      <Chip
        :label="printControl.endorsementNumber.toString()"
        icon="pi pi-sort-numeric-down"
        class="mr-2 mb-2"
        v-primeTooltip.top="{ value: 'Endoso' }"
      />
      <Button
        v-if="showReload"
        icon="pi pi-history"
        label="Recargar"
        @click="reload($event)"
      />
    </div>
    <div class="flex align-items-center flex-column sm:flex-row">
      <TreeTable :value="treeNodes" class="p-treetable-sm">
        <Column
          field="documentName"
          header="Nombre"
          :expander="true"
          style="width: 200px"
        ></Column>
        <!-- <Column field="type" header="Tipo" style="width: 200px"></Column>
        <Column field="state" header="Estado" style="width: 200px"></Column> -->
        <Column
          header="Tipo Impresion / Estado / Descripción Estado"
          headerStyle="width: 200px"
          bodyStyle="width: 200px"
        >
          <!-- field="stateDescription" -->
          <template #body="slotProps">
            <Tag
              :value="slotProps.node.data.type"
              icon="pi pi-file-pdf"
              class="mr-2 mb-2"
            ></Tag>
            <Tag
              :value="slotProps.node.data.state"
              icon="pi pi-info-circle"
              class="mr-2 mb-2"
            ></Tag>
            <Tag
              :value="slotProps.node.data.stateDescription"
              class="mr-2 mb-2 gray-tag"
            ></Tag>
            <Button
              v-if="
                slotProps.node.data.documentId == 0 &&
                slotProps.node.data.packageId > 0 &&
                showIntegrations
              "
              class="p-button-outlined p-button-rounded p-button-info mr-2 mb-2"
              type="button"
              icon="pi pi-info"
              v-primeTooltip="'Ver Integraciones'"
              @click="getIntegrations(slotProps.node.data)"
            />
            <Button
              v-if="
                slotProps.node.data.documentId == 0 &&
                slotProps.node.data.packageId > 0 &&
                showIntegrations
              "
              class="p-button-outlined p-button-rounded p-button-info mr-2 mb-2"
              type="button"
              icon="pi pi-print"
              v-primeTooltip="'Reimprimir'"
              @click="getInformationPrint(slotProps.node.data)"
            />
            <!-- <Chip
              :label="slotProps.node.data.type"
              icon="pi pi-file-pdf"
              
              style="text-transform: initial"
            />
            <Chip
              :label="slotProps.node.data.state"
              icon="pi pi-info-circle"
              class="mr-2 mb-2"
              style="text-transform: initial"
            />
            <Chip
              :label="slotProps.node.data.stateDescription"
              icon="pi pi-comment"
              class="mr-2"
              style="text-transform: initial"
            /> -->
            <Button
              v-if="
                slotProps.node.data.documentId > 0 &&
                slotProps.node.data.canDownload == true &&
                slotProps.node.data.hasIndividualItems == false
              "
              type="button"
              label="Descargar"
              icon="pi pi-download"
              class="p-button-info"
              v-primeTooltip="'Descargar Archivo'"
              @click="DownloadFile(slotProps.node.data)"
            />
          </template>
        </Column>
      </TreeTable>
    </div>
    <!-- <OverlayPanel
      ref="opManual"
      style="width: 600px; z-index: 1003"
      :showCloseIcon="true"
      :dismissable="false"
      :baseZIndex="1002"
      :autoZIndex="false"
    >
      <dashboard-manual
        ref="manual"
        @OnPrintAction="getInformationPrint"
      >
      </dashboard-manual>
    </OverlayPanel> -->
    <Dialog header="Integraciones" :visible.sync="showdialog">
      <span v-if="loadedIntegrations.length == 0"
        >No se encuentran integraciones</span
      >
      <div v-for="item in loadedIntegrations" :key="item.key">
        <Message :severity="item.severity" :closable="false">
          <div style="text-align: left">
            <Badge :value="item.type" :severity="item.severity"></Badge
            ><Badge
              class="ml-2"
              :value="item.statusId"
              :severity="item.severity"
            ></Badge>
          </div>
          {{ item.statusText }}
        </Message>
      </div>
    </Dialog>
  </div>
</template>

<script>
/*Imports de VueJS*/
import Vue from "vue";
import TreeTable from "primevue/treetable";
import Column from "primevue/column";
import Tag from "primevue/tag";
import Chip from "primevue/chip";
import download from "downloadjs";

import Tooltip from "primevue/tooltip";
import ToastMixin from "../../mixins/ToastMixin";
import Dialog from "primevue/dialog";
import Message from "primevue/message";
import Badge from "primevue/badge";
//import OverlayPanel from "primevue/overlaypanel";

import PermissionMixin from "../../mixins/PermissionMixin";

export default Vue.extend({
  name: "HistoryOverlay",
  components: {
    TreeTable,
    Column,
    Chip,
    Tag,
    Dialog,
    Message,
    Badge
    //OverlayPanel
  },
  directives: {
    primeTooltip: Tooltip
  },
  mixins: [PermissionMixin, ToastMixin],
  computed: {
    loadedIntegrations() {
      return this.integrations.map((x) => {
        var severity = "info";
        if (x.isFinish && !x.isSuccess) severity = "warn";
        if (x.isFinish && x.isSuccess) severity = "success";
        if (!x.isFinish && !x.isSuccess) severity = "info";
        return {
          key:
            x.processId +
            "-" +
            x.packageId +
            "-" +
            x.historyId +
            "-" +
            x.integrationId +
            "-" +
            x.documentId,
          statusId: x.stateId + "-" + x.description,
          statusText: x.stateDescription,
          type: x.integrationName + " (" + x.integrationType + ")",
          severity: severity
        };
      });
    },
    showIntegrations() {
      return this.hasPermission("CanPrintManual");
    }
  },
  created() {},
  mounted() {
    this.treeNodes = this.currentData;
  },
  beforeDestroy() {
    this.treeNodes = [];
  },
  data() {
    return { treeNodes: null, showdialog: false, showdialogPrint: false, integrations: [], informationPrint: [] };
  },
  methods: {
    // setCurrentData(data) {
    //   console.log(data);
    //   this.treeNodes = [];
    //   var newArray = JSON.parse(JSON.stringify(data));
    //   newArray.forEach((element) => {
    //     this.treeNodes.push(element);
    //   });
    //   console.log(newArray);
    // },
    showData(args) {
      console.log(args);
    },
    refresh(data) {
      this.treeNodes = data;
    },
    getBlobFromFile(file) {
      try {
        var buffer = Buffer.from(file.fileContents, "base64");
        var blob = new Blob([buffer]);
        return blob;
      } catch (error) {
        return null;
      }
    },
    reload(event) {
      this.$emit("ReloadClicked", event);
    },
    async getIntegrations(args) {
      var query = {
        processId: args.processId,
        historyId: args.historyId,
        packageId: args.packageId
      };

      this.integrations = [];

      try {
        var response = await this.$store.dispatch(
          "dashboard/getControlIntegrations",
          query
        );

        this.integrations = response;
        this.showdialog = true;
        console.log(this.integrations)
      } catch (error) {
        this.showToast("Error!", "Otbteniendo integraciones: " + error, 2000);
      }
    },
    async getInformationPrint(data) {
      this.$parent.showLoading();

      var query = {
        processId: data.processId,
        historyId: data.historyId,
        packageId: data.packageId,
        queueId : -1
      };

      this.informationPrint = [];

      console.log("Query")
        console.log(query)
        console.log("Data")
        console.log(data)

      try {
        var response = await this.$store.dispatch(
          "dashboard/requeuePrint",
          query
        );

        this.informationPrint = response;
        this.showdialogPrint = true;

        if (response) {
          this.$parent.hideLoading(500);
          this.showToast(
            "En Cola!",
            "Se ha puesto en cola la Reimpresión solicitada.",
            4000
          );
          this.reload()
        }
      } catch (error) {
          this.showToast(
            "Error!",
            "Ha ocurrido un error al encolar la Reimpresión!",
            4000
          );
        
        console.log(error)
      }
    },
    async DownloadFile(args) {
      var query = {
        processId: args.processId,
        historyId: args.historyId,
        packageId: args.packageId,
        documentId: args.documentId,
        documentNumber: args.documentNumber
      };
      try {
        console.log("Argumentos:", args);
        var response = await this.$store.dispatch(
          "dashboard/getDocumentPDF",
          query
        );

        if (response.status != undefined) {
          if (response.status == 401) {
            this.showToast("Error 401", "No estás autorizado!", 2000);
          } else if (response.status == 400) {
            if (response.data != undefined) {
              if (response.data.statusCode == 204) {
                this.showToast(
                  "Atención!",
                  "El archivo solicitado no se ha encontrado!",
                  2000
                );
                return;
              }
            }

            this.showToast(
              "Error",
              "Ha ocurrido un error descargando el archivo",
              2000
            );
          } else if (response.status == 204) {
            this.showToast(
              "Atención!",
              "El archivo solicitado no se ha encontrado!",
              2000
            );
          }
        } else if (response.statusCode != undefined) {
          if (response.statusCode == 200) {
            this.showToast(
              "Confirmación!",
              "Descargando archivo: " + response.fileName,
              2000
            );
            var downBlob = this.getBlobFromFile(response);
            if (downBlob != null) {
              download(downBlob, response.fileName, response.contentType);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  props: {
    showReload: {
      type: Boolean,
      required: false
    },
    printControl: {
      type: Object,
      required: true,
      default: function () {
        return null;
      }
    },
    currentData: {
      type: Array,
      required: true,
      default: function () {
        return [];
      }
    }
  }
});
</script>

<style>
@import url(../../../node_modules/vue-loading-overlay/dist/vue-loading.css);

.p-overlaypanel {
  max-width: 90% !important;
  /* offset-x | offset-y | blur-radius | color */
  box-shadow: 5px 5px 5px 3px #ccc;
  z-index: 1003 !important;
}

div.p-tooltip {
  z-index: 1010 !important;
}

th.big-col td.big-col {
  width: 500px;
}

.gray-tag {
  background-color: #eee;
  color: #000;
}
</style>
